// TotalModa Modern Scroll Animations - Keyframes Safe Architecture
(function() {
  function initKeyframeAnimations() {
    if (!('IntersectionObserver' in window)) return;

    const selectors = [
      '.collection-card',
      '.collection-list__item',
      'product-card',
      '.product-card',
      '.resource-list__item',
      '.swarovski-split-grid > *',
      '.swarovski-content-card',
      '.image-with-text__grid > *',
      '.rich-text__blocks',
      '.multicolumn-card'
    ];

    const elements = document.querySelectorAll(selectors.join(', '));
    if (!elements.length) return;

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('tm-animated');
          obs.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -40px 0px',
      threshold: 0.05
    });

    const windowHeight = window.innerHeight || 800;

    elements.forEach(el => {
      // Ignoram orice e in header / drawer / announcement
      if (el.closest('header') || el.closest('.header-section') || el.closest('.announcement-bar') || el.closest('.menu-drawer')) {
        return;
      }

      const rect = el.getBoundingClientRect();
      // Daca este deja in prima parte a ecranului la pornire, nu adaugam delay
      if (rect.top < windowHeight * 0.8 && rect.bottom > 0) {
        el.classList.add('tm-animated');
      } else {
        observer.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKeyframeAnimations);
  } else {
    initKeyframeAnimations();
  }
})();
